import { createContext, ReactNode, useMemo } from 'react'

interface IContentsModalContextData {
  setIsOpen: (isOpen: number) => void
  isOpen: boolean
}

export const ContentsModalContext = createContext<IContentsModalContextData>(
  {} as IContentsModalContextData,
)

export function ContentsModalProvider({
  children,
  setIsOpen,
  isOpen,
}: {
  children: ReactNode
} & IContentsModalContextData) {
  const contextValue = useMemo(
    () => ({ setIsOpen, isOpen }),
    [setIsOpen, isOpen],
  )

  return (
    <ContentsModalContext.Provider value={contextValue}>
      {children}
    </ContentsModalContext.Provider>
  )
}
